import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slider", "value", "share", "segment"];

  connect() {
    this.update();
  }

  update() {
    const weights = this.sliderTargets.map((slider) => Number(slider.value));
    const total = weights.reduce((sum, weight) => sum + weight, 0) || 1;
    weights.forEach((weight, index) => {
      const share = Math.round((weight / total) * 100);
      this.valueTargets[index].textContent = weight;
      this.shareTargets[index].textContent = `${share}%`;
      this.segmentTargets[index].style.flexGrow = weight;
      this.segmentTargets[index].title = `${this.segmentTargets[index].dataset.label} ${share}%`;
    });
  }

  reset() {
    this.sliderTargets.forEach((slider) => { slider.value = 50; });
    this.update();
  }
}
